import { render } from "./CollapsiblePanel.vue?vue&type=template&id=681b74f4"
import script from "./CollapsiblePanel.vue?vue&type=script&lang=js"
export * from "./CollapsiblePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__